import { writable } from 'svelte/store';
import type { Stats } from '../types';
import { api } from '../api';

export const stats = writable<Stats | null>(null);

let timer: ReturnType<typeof setInterval> | null = null;

export async function refreshStats(): Promise<void> {
  try {
    stats.set(await api.stats());
  } catch {
    // keep the last good snapshot; the health dot degrades via fetch_health, not by clearing
  }
}

export function startStatsPoll(ms = 60_000): void {
  stopStatsPoll();
  void refreshStats();
  timer = setInterval(() => void refreshStats(), ms);
}

export function stopStatsPoll(): void {
  if (timer !== null) {
    clearInterval(timer);
    timer = null;
  }
}
